(function () {
  var CLS = "HFB-074-AB--var-1";
  var HANDLE = "everywhere-wipes";
  var hold = false;
  var holdTimer = 0;
  var resume = null;
  var variantId = null;
  var priceLabel = "$6.98";

  function on() {
    return document.documentElement.classList.contains(CLS);
  }

  function currentHandle() {
    var match = (location.pathname || "").match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function sheet() {
    return document.querySelector(".hfb-074");
  }

  function metaLine() {
    var titleEl = document.querySelector(".product-main-title, h1");
    var title = titleEl ? titleEl.textContent.replace(/\s+/g, " ").trim() : "Your item";
    if (title.length > 42) title = title.slice(0, 40).trim() + "…";
    var strength = document.querySelector(".bm-strength-btn.is-active, .bm-strength .is-active, [data-strength].is-selected");
    var strengthText = strength ? strength.textContent.replace(/\s+/g, " ").trim() : "";
    var subscribed = !!document.querySelector(".product-subscription-item.is-active input:checked, .product-subscription input:checked, input[name='selling_plan'][value]:not([value=''])");
    var selling = document.querySelector("input[name='selling_plan']");
    if (selling && selling.value && selling.value !== "undefined") subscribed = true;
    var bits = [title];
    if (strengthText) bits.push(strengthText);
    bits.push(subscribed ? "Subscribe" : "One-time");
    return bits.join(" · ");
  }

  function show(done) {
    var root = sheet();
    if (root && root.parentNode !== document.body) document.body.appendChild(root);
    if (!root) {
      done();
      return;
    }
    var meta = root.querySelector("[data-hfb-074-meta]");
    var price = root.querySelector("[data-hfb-074-price]");
    if (meta) meta.textContent = metaLine();
    if (price) price.textContent = "+ " + priceLabel;
    resume = done;
    root.hidden = false;
  }

  function finish() {
    var root = sheet();
    if (root) root.hidden = true;
    var next = resume;
    resume = null;
    if (next) next();
  }

  function loadProduct() {
    fetch("/products/" + HANDLE + ".js")
      .then(function (res) { return res.json(); })
      .then(function (product) {
        var variant = (product.variants || [])[0];
        if (!variant) return;
        variantId = variant.id;
        if (typeof Shopify !== "undefined" && Shopify.formatMoney && window.theme && theme.moneyFormat) {
          priceLabel = Shopify.formatMoney(variant.price, theme.moneyFormat);
        } else {
          priceLabel = "$" + (variant.price / 100).toFixed(2);
        }
      })
      .catch(function () {});
  }

  function addWipes() {
    if (!variantId) return;
    var button = document.querySelector("[data-hfb-074-add]");
    if (button) button.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function () {
        if (window.robustCart && window.robustCart.refreshCart) return window.robustCart.refreshCart();
      })
      .finally(function () {
        if (button) button.disabled = false;
        finish();
      });
  }

  function patch() {
    if (!window.robustCart || window.robustCart.__hfb074) return !!window.robustCart;
    var orig = window.robustCart.openCart.bind(window.robustCart);
    window.robustCart.openCart = function () {
      window.clearTimeout(holdTimer);
      if (hold && on() && currentHandle() !== HANDLE) {
        hold = false;
        show(orig);
        return;
      }
      hold = false;
      orig();
    };
    window.robustCart.__hfb074 = true;
    return true;
  }

  document.addEventListener(
    "click",
    function (event) {
      if (!on() || currentHandle() === HANDLE) return;
      var button = event.target.closest("button[name='add']");
      var form = button && button.closest("form[action*='/cart/add']");
      if (!form) return;
      hold = true;
      window.clearTimeout(holdTimer);
      holdTimer = window.setTimeout(function () { hold = false; }, 8000);
    },
    true
  );

  document.addEventListener("click", function (event) {
    if (!on()) return;
    if (event.target.closest("[data-hfb-074-add]")) {
      event.preventDefault();
      addWipes();
      return;
    }
    if (event.target.closest("[data-hfb-074-cart], [data-hfb-074-dismiss]")) {
      event.preventDefault();
      finish();
    }
  });

  function boot() {
    if (!on()) return;
    loadProduct();
    if (!patch()) {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (patch() || tries > 40) clearInterval(timer);
      }, 150);
    }
  }

  function watch() {
    if (on()) {
      boot();
      return;
    }
    var obs = new MutationObserver(function () {
      if (on()) {
        obs.disconnect();
        boot();
      }
    });
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watch);
  else watch();
})();
